module.exports = __webpack_public_path__ + "static/media/marion-rudelle.c5ea54a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/marion-rudelle.jpg
// module id = 1825
// module chunks = 0